import { validateEnumTranslations } from '../../safety_checks';

//⚠️IMPACT attention changer aussi l'enum Prisma `MemberAssignmentStrategy` dans schema.prisma
// (même valeurs, même ordre).
// Ordre d'essai des membres quand le client choisit « Sans préférence » dans le tunnel :
// la stratégie ne change que l'ORDRE des candidats, jamais qui est éligible.
export enum MemberAssignmentStrategy {
  PRIORITY = 'PRIORITY',
  BALANCED = 'BALANCED',
}

export const MEMBER_ASSIGNMENT_STRATEGY_TRANSLATE_KEY = 'MEMBER_ASSIGNMENT_STRATEGY_';

export const MemberAssignmentStrategyTranslation = {
  'fr-FR': {
    [`${MEMBER_ASSIGNMENT_STRATEGY_TRANSLATE_KEY}${MemberAssignmentStrategy.PRIORITY}`]:
      'Par priorité : le premier disponible dans l’ordre de la page Équipe',
    [`${MEMBER_ASSIGNMENT_STRATEGY_TRANSLATE_KEY}${MemberAssignmentStrategy.BALANCED}`]:
      'Équilibré : le membre le moins chargé de la journée en premier',
  },
};

validateEnumTranslations(
  MemberAssignmentStrategy,
  MemberAssignmentStrategyTranslation,
  MEMBER_ASSIGNMENT_STRATEGY_TRANSLATE_KEY,
  true,
);
